var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.128 18.385a11.53 11.53 0 002.046-6.573c0-6.4-5.187-11.587-11.587-11.587C5.187.225 0 5.412 0 11.812c0 6.399 5.187 11.587 11.587 11.587 2.671 0 5.13-.907 7.09-2.425l6.802 6.802L28 25.256l-6.872-6.871zm-9.54 2.518c-5.014 0-9.092-4.078-9.092-9.091 0-5.013 4.078-9.092 9.091-9.092 5.013 0 9.091 4.078 9.091 9.092 0 5.013-4.078 9.091-9.09 9.091z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.835 10.742V6.285h-2.496v4.457H5.882v2.495h4.457v4.457h2.495v-4.456h4.457v-2.496h-4.457z"
  })));
}

export default SvgZoomIn;